import { ErrorBoundary } from "@sentry/react";
import React, { useContext } from "react";
import { RouteComponentProps, withRouter } from "react-router-dom";
import { ErrorMsg, NoDataMsg } from "../../../../components/AppMessages";
import { AVG_APP_RATINGS_COLORS } from "../../../../constants";
import { ThemeContext } from "../../../../context";
import VocSalesTopicChart from "../../../../components/Charts/VOC/VocSalesTopicChart";

interface Props {
  categories: Array<string>;
  chartData: any;
  topicClassificationLoading: boolean;
}

const TopCategories = withRouter((props: RouteComponentProps & Props) => {
  const { categories, chartData, topicClassificationLoading } = props;

  const themeContext = useContext(ThemeContext);

  const colorMapping = categories?.map((category: string, index: number) => {
    return { [category]: AVG_APP_RATINGS_COLORS[index] };
  });

    return (
    <ErrorBoundary fallback={<ErrorMsg />}>
      <div>
        {chartData && chartData.length > 0 ? (
          chartData?.map((item: any) => {
            return item.topics && item.topics.length > 0 ? (
              <div className="row grid" key={item.market}>
                <div className="tile min-h-20 grid-col-span-6 flex-row">
                  <div className=" market-answers">
                    <p className="bold">{item.market}</p>
                    <p>{item.answers}% of answers</p>
                  </div>
                  <div className="categoryContainer">
                    <VocSalesTopicChart
                      chartId={`vocTopicChart${item.market}`}
                      data={item.topics}
                      theme={themeContext.theme}
                      colorMapping={colorMapping?.reduce((acc, curr) => ({ ...acc, ...curr }), {})}
                      isLoading={topicClassificationLoading}
                    />
                  </div>
                </div>
              </div>
            ) : null
              
          })):
          < div className="tile " style={{minHeight: '300px'}}>
           <NoDataMsg />
          </div>
          }
      </div>
    </ErrorBoundary>
  );
});

export default TopCategories;
